"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const marqueeContainer = "pl-m1t77n1p";
const marqueeStyles = "pl-macgsi1";

// Single child measurer
const singleChildStyles = "pl-s1b695f2";

/**
 * Marquee Component.
 *
 * @param {Object} props React props
 * @param {Boolean} props.play Play State
 * @param {Boolean} props.pauseOnHover Pause When Hover
 * @param {Boolean} props.pauseOnClick Pause When Click
 * @param {String} props.direction LTR | RTL Slide Direction
 * @param {Number} props.speed Animation Speed
 * @param {Number} props.delay Animation delay default = 0
 * @param {Node} props.children Node
 * @returns {React.ReactElement} Marquee Component
 * @public
 */

function Marquee({
  play = true,
  pauseOnHover = false,
  pauseOnClick = false,
  direction = 'left',
  speed = 20,
  delay = 0,
  children
}) {
  const containerRef = (0, _react.useRef)(null);
  const contentRef = (0, _react.useRef)(null);
  const containerWidth = (0, _patternLibraryUtils.useWidthObserver)(containerRef);
  const singleChildRef = (0, _react.useRef)(null);
  const baseWidth = (0, _patternLibraryUtils.useWidthObserver)(singleChildRef);
  const directionVar = direction === 'left' ? 'normal' : 'reverse';
  const duration = baseWidth > 0 ? baseWidth / speed : 0;
  const isRunning = play;
  const MAX_REPEATS = 4;
  const repeatCount = baseWidth > 0 && containerWidth > 0 ? Math.min(MAX_REPEATS, Math.max(2, Math.ceil((containerWidth + baseWidth) / baseWidth))) : 2;
  const repeatArray = (0, _react.useMemo)(() => Array.from({
    length: repeatCount
  }), [repeatCount]);

  // first child is measured, rest are duplicates
  const repeatedChildren = (0, _react.useMemo)(() => repeatArray.map((_, i) => /*#__PURE__*/_react.default.createElement("div", {
    key: `a-${i}`,
    className: singleChildStyles,
    ref: i === 0 ? singleChildRef : null
  }, children)), [repeatArray, children]);
  const conditionalStyles = {
    '--play': isRunning ? 'running' : 'paused',
    '--direction': directionVar,
    '--duration': `${duration}s`,
    '--delay': `${delay}s`,
    ...(pauseOnHover ? {
      '--pause-on-hover': 'paused'
    } : {}),
    ...(pauseOnClick ? {
      '--pause-on-click': 'paused'
    } : {}),
    ...(baseWidth > 0 ? {
      '--distance': `${baseWidth}px`
    } : {})
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef,
    "data-cy": "fast-marquee",
    className: marqueeContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: contentRef,
    className: marqueeStyles,
    style: conditionalStyles
  }, repeatedChildren));
}
var _default = exports.default = Marquee;
Marquee.propTypes = {
  play: _propTypes.default.bool,
  pauseOnHover: _propTypes.default.bool,
  pauseOnClick: _propTypes.default.bool,
  direction: _propTypes.default.oneOf(['left', 'right']),
  speed: _propTypes.default.number,
  delay: _propTypes.default.number,
  children: _propTypes.default.node
};